var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-size"},[[_c('ui-input-select',{staticClass:"select",attrs:{"value":_vm.value,"options":_vm.pageSizeOptions,"clearable":false,"reduce":function (ref) {
	var value = ref.value;

	return value;
}},on:{"update":function($event){return _vm.$emit('update', $event)}}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }